module.exports = __webpack_public_path__ + "img/menu-2.181d349f.png";